import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ThemeContext } from '../../../auth';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import axios from '../../../api/axios';
import Swal from 'sweetalert2';
import { Formik } from 'formik';
import Select from 'react-select';

function ModalUbahRuanganRequest({
    meetingid,
    showEditRuanganRequest,
    setShowEditRuanganRequest,
    rowSelected,
    retrieveDetailMeeting,
    tokenUser
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [timeBlockRuangan, setTimeBlockRuangan] = useState([]);
    const [listRuangan, setListRuangan] = useState([]);

    const handleClose = () => {
        setShowEditRuanganRequest(false);
    };

    const tanggal = rowSelected?.waktu_mulai.split('T')[0];

    const retrieveRuangan = () => {
        axios.get(`/manage/ruangan/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setListRuangan(res.data);

            }).catch(err => {

                console.error(err);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data pada server!',
                });
            })
    }

    useEffect(() => {
        if (tokenUser !== undefined) retrieveRuangan()
    }, [tokenUser]);

    const retrieveAvailableRuangan = () => {

        axios.get(`/manage/requests/filter_by_date_and_ruangan/?date=${tanggal}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {
                // console.log(res.data)
                setTimeBlockRuangan(res.data);

            }).catch(err => {

                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // navigate('/');
                        }
                    });
                } else {
                    console.error(err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal memuat data pada server!',
                    });
                }
            })
    }

    useEffect(() => {
        if (tokenUser !== undefined && tanggal !== undefined) retrieveAvailableRuangan()
    }, [tokenUser, tanggal]);


    const defaultValue = {
        ruangan: rowSelected?.ruangan || '',
    };

    const availableRuanganOptions = useMemo(() => {
        if (!rowSelected) return [];

        const start = new Date(rowSelected.waktu_mulai);
        const end = new Date(rowSelected.waktu_selesai);


        const blockedRuanganIds = timeBlockRuangan
            .filter(item => item.id !== rowSelected.id)
            .filter(item => {
                const itemStart = new Date(item.waktu_mulai);
                const itemEnd = new Date(item.waktu_selesai);

                return !(itemEnd <= start || itemStart >= end);
            })
            .map(item => item.ruangan);

        const filterRuangan = listRuangan
            .filter(ruangan =>
                !blockedRuanganIds.includes(ruangan.id) &&
                ruangan.id !== rowSelected.ruangan
            )
            .map(ruangan => ({
                value: ruangan.id,
                label: ruangan.nama_ruangan,
            }));

        return filterRuangan;
    }, [listRuangan, timeBlockRuangan, rowSelected]);


    const handleSelectRuangan = (selectedOption, setFieldValue) => {
        setFieldValue('ruangan', selectedOption ? selectedOption.value : "");
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? 'white' : '#222'
        },
        button: {
            height: '50px',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const handleSubmitRequest = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        try {

            await axios.patch(`/manage/requests/${meetingid}/`, values, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah ruangan meeting',
                showConfirmButton: true,
            });

            retrieveDetailMeeting();

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah ruangan meeting',
            });
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };


    return (
        <Modal
            show={showEditRuanganRequest}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Ubah Ruangan Meeting
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitRequest}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue
                    }) => (
                        <Form
                            onSubmit={handleSubmit}
                        >
                            <Form.Group className='mb-3'>
                                <Form.Label style={formStyles.label} htmlFor='ruangan'>Ruangan*</Form.Label>
                                <Select
                                    id='ruangan'
                                    required
                                    options={availableRuanganOptions}
                                    defaultValue={availableRuanganOptions.find(option => option.value === defaultValue.ruangan)}
                                    onChange={(selectedOption) => handleSelectRuangan(selectedOption, setFieldValue)} styles={selectStyles}
                                    placeholder='Select...'
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahRuanganRequest
